import React, { useEffect, useLayoutEffect, useState } from 'react';
import ReactDOM from 'react-dom';

import {
	useClassNames,
	GUID,
} from '@common';

import {
	Divider,
} from '@components';

import {
	useModalContext,
} from './ModalProvider';

import './Modal.scss';

interface ModalProps {
	isOpen: boolean,
	className?: string,
	header?: JSX.Element | JSX.Element[],
	footer?: JSX.Element | JSX.Element[],
	children?: JSX.Element | JSX.Element[],
}

function Modal(props: ModalProps): JSX.Element {
	const {
		footer,
		header,
		isOpen,
		children,
		className,
	} = props;

	const {
		addModal,
		closeModal,
		// openedModalGuids,
	} = useModalContext();

	const
		[modalContainer, setModalContainer] = useState<Element>(null),
		[uuid, setUuid] = useState<string>(null);

	useEffect(() => {
		setUuid(GUID());
	}, []);

	useLayoutEffect(() => {
		setModalContainer(document.getElementById('modal-container'));
	}, []);

	useEffect(() => {
		if (isOpen) {
			addModal(uuid);
		} else {
			closeModal(uuid);
		}

		return closeModal(uuid);
	}, [uuid, isOpen, addModal, closeModal]);

	const classes = useClassNames(
		'modal',
		className,
	);

	return modalContainer && isOpen && ReactDOM.createPortal(
		(
			<div className="modal-mask">
				<div className={classes}>
					<div className="modal__header">
						{header}
					</div>
					<div className="modal__content">
						{children}
					</div>
					{footer && <Divider className='modal__divider' gap="24px" />}
					<div className="modal__footer">
						{footer}
					</div>
				</div>
			</div>
		),
		modalContainer,
	);
}

export {Modal};